module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="content-header">\r\n    <h1>\r\n        '+
((__t=(lang.ENVIRO))==null?'':_.escape(__t))+
'\r\n    </h1>\r\n</section>\r\n\r\n<section class="content">\r\n    <div class="row">\r\n        <div class="col-md-12 folderView">\r\n\r\n            ';
 if(role==="0")
                print(  '<div class="col-lg-3 col-md-4 col-sm-6 col-xs-12"><div class="info-box iii">' + 
                            '<span class="info-box-icon bg-green pointer" id="addInstance"><i class="ion ion-ios-plus-outline"></i></span>' + 
                            '<div class="info-box-content">'+
                                '<span class="info-box-text">' + lang.ADD + '</span>'+
                                '<span class="info-box-number">' + lang.ENVIRO + '</span>' +
                            '</div>' +
                        '</div></div>');
            
__p+='\r\n                ';

            _.each(models, function(model){
               
                print(  '<div class="col-lg-3 col-md-4 col-sm-6 col-xs-12"><div class="info-box iii">' + 
                        '<span class="info-box-icon bg-white no-margin instanceItem pointer  imagg_kk" data-id="' + model.id + '" >'+
                           '<img class="instanceItem  insta_immma" data-id="' + model.id + '" type="icon" id="icon' + model.id + '"/></span>'+
                        '<div class="info-box-content">'+                            
                        '<span class="info-box-number name_innss_xx">' + model.attributes.name + '</span>');
                            
                if(role==="0"){
                    print(  '<span class="info-box-text"><span data-id="' + model.id + '" class="btn btn-flat btn-default btn-sm editInstanceItem">' + lang.EDIT + '</span></span>');    
                }
 

                if( model.attributes.is_mapa > 0){
                    print(  '<span class="info-box-text mapps_oo">TIENE GIS</span>');  
                }else{
                    print(  '<span class="info-box-text nomap mapps_oo">NO TIENE GIS</span>');   
                }
                   
                print(  '</div></div></div>');
            });  
            
__p+='\r\n\r\n\r\n\r\n        </div>\r\n    </div>\r\n    </div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/instances/instancesView.ejs
// module id = 422
// module chunks = 0